<div class="d-flex" [class.hiddenImp]="hideInput">
    <div [ngClass]="{'file-required': isRequired}" id="fakeInput" #uploadFilename class="form-control text-truncate" [ngClass]="cssClass" (blur)="onBlur($event)"
        [ngClass]="{ 'is-invalid': invalidFile || maxSize}" [ngStyle]="{'cursor': false ? 'pointer' : 'default'}">
        <span *ngIf="!fileName && placeholder" class="placeholder">{{ placeholder }}</span>
        <span *ngIf="fileChanged">{{ fileName }}</span>
        <span style="cursor: pointer;" *ngIf="!fileChanged" (click)="onViewDocument()">{{ fileName }}</span>
    </div>
    <!-- <input type="text" class="form-control" [value]="file?.name" [disabled]="disabled" [readonly]="readonly" placeholder="{{placeholder}}"/> -->
    <button style="margin-left: 10px;" class="btn btn-browse d-flex justify-content-center" (click)="attachment.click()"
        [disabled]="disabled">
        <div class="folder-open"></div>{{'Browse' | translate}}
    </button>
    <input hidden="true" type="file" accept="{{fileAccept}}" #attachment>
</div>

<ng-container [ngTemplateOutlet]="isRequired ? requiredTemplate : invalidFile ? invalidTemplate : maxSize ? maxSizeTemplate : fileInputMessage ? fileInputMessageTemplate : null"></ng-container>
<ng-template #requiredTemplate>
  <small class="form-text text-danger">{{'You must enter a value' | translate}}</small>
</ng-template>
<ng-template #invalidTemplate>
  <small class="form-text text-danger">{{'Invalid file type.' | translate}}</small>
</ng-template>
<ng-template #maxSizeTemplate>
  <small class="form-text text-danger">{{maxSize}}</small>
</ng-template>
<ng-template #fileInputMessageTemplate>
  <small class="form-text text-danger">{{fileInputMessage | translate}}</small>
</ng-template>

<div *ngIf="drop" [hidden]="disabled" class="drop-file" [class]="classDrop" appDnd (fileDropped)="onFileDropped($event)" (click)="onClickDrop()">
    <div class="text">
        <div class="icon-drag"></div>
        <div class="text__">{{'Drop your file here' | translate}}</div>
    </div>
</div>
